<div *ngIf="loader" id="spinerLoader" class="container">
    <ds-loading-spinner [diameter]="100" [strokeWidth]="11" color="#b52323"></ds-loading-spinner>
</div>
<div class="card-body-tab">
    <div class="col-12 px-2">
        <div class="cards-body">
            <div class="needs-review-filter">
                <label class="needs-review-filter__label mb-0">
                    <input
                        type="checkbox"
                        [(ngModel)]="showAwaitingVerificationOnly"
                        (ngModelChange)="onAwaitingVerificationFilterChange()"
                    />
                    Needs verification
                </label>
            </div>
            <div class="tableSpacing">
                <div class="box-body table-responsive-sm table-responsive-md table-responsive-lg overflow-x-auto">
                    <table id="blocktime_report_table" class="table card-layout table-striped table">
                        <thead>
                            <tr id="blocktimeRecord_headingId">
                                <td class="header_td table_heading">
                                    <div class="header_container text-primary">
                                        <div
                                            class="header-color cursorPointer reportfield-width background-color-whiteSmoke box-shadow-whiteSmoke position-sticky left-minus_0_5"
                                        >
                                            Action
                                        </div>
                                        <div
                                            class="header-color cursorPointer reportfield-width background-color-whiteSmoke position-sticky left-9_5"
                                            (click)="
                                                sortBy = 'srCreatedOnDate';
                                                sortOrder = !sortOrder;
                                                blockTimeReportSorting.srCreatedOnDate = !blockTimeReportSorting.srCreatedOnDate
                                            "
                                        >
                                            Date
                                            <ds-icon
                                                *ngIf="blockTimeReportSorting.srCreatedOnDate"
                                                name="expand_less"
                                                size="inherit"
                                                class="margin-left-7"
                                            ></ds-icon>
                                            <ds-icon
                                                *ngIf="!blockTimeReportSorting.srCreatedOnDate"
                                                name="expand_more"
                                                size="inherit"
                                                class="margin-left-7"
                                            ></ds-icon>
                                        </div>
                                        <div
                                            class="header-color cursorPointer reportfield-width background-color-whiteSmoke position-sticky left-19_5"
                                            (click)="
                                                sortBy = 'tripID';
                                                sortOrder = !sortOrder;
                                                blockTimeReportSorting.tripID = !blockTimeReportSorting.tripID
                                            "
                                        >
                                            Trip #
                                            <ds-icon
                                                *ngIf="blockTimeReportSorting.tripID"
                                                name="expand_less"
                                                size="inherit"
                                                class="margin-left-7"
                                            ></ds-icon>
                                            <ds-icon
                                                *ngIf="!blockTimeReportSorting.tripID"
                                                name="expand_more"
                                                size="inherit"
                                                class="margin-left-7"
                                            ></ds-icon>
                                        </div>
                                        <div
                                            class="header-color cursorPointer reportfield-width background-color-whiteSmoke position-sticky left-29_5"
                                            (click)="
                                                sortBy = 'customerName';
                                                sortOrder = !sortOrder;
                                                blockTimeReportSorting.customerName = !blockTimeReportSorting.customerName
                                            "
                                        >
                                            Customer
                                            <ds-icon
                                                *ngIf="blockTimeReportSorting.customerName"
                                                name="expand_less"
                                                size="inherit"
                                                class="margin-left-7"
                                            ></ds-icon>
                                            <ds-icon
                                                *ngIf="!blockTimeReportSorting.customerName"
                                                name="expand_more"
                                                size="inherit"
                                                class="margin-left-7"
                                            ></ds-icon>
                                        </div>
                                        <div
                                            class="header-color cursorPointer reportfield-width"
                                            (click)="
                                                sortBy = 'serviceType';
                                                sortOrder = !sortOrder;
                                                blockTimeReportSorting.serviceType = !blockTimeReportSorting.serviceType
                                            "
                                        >
                                            SR Type
                                            <ds-icon
                                                *ngIf="blockTimeReportSorting.serviceType"
                                                name="expand_less"
                                                size="inherit"
                                                class="margin-left-7"
                                            ></ds-icon>
                                            <ds-icon
                                                *ngIf="!blockTimeReportSorting.serviceType"
                                                name="expand_more"
                                                size="inherit"
                                                class="margin-left-7"
                                            ></ds-icon>
                                        </div>
                                        <div
                                            class="header-color cursorPointer reportfield-width reportfield-width-14"
                                            (click)="
                                                sortBy = 'additionalOrgans';
                                                sortOrder = !sortOrder;
                                                blockTimeReportSorting.additionalOrgans = !blockTimeReportSorting.additionalOrgans
                                            "
                                        >
                                            Organ Type
                                            <ds-icon
                                                *ngIf="blockTimeReportSorting.additionalOrgans"
                                                name="expand_less"
                                                size="inherit"
                                                class="margin-left-7"
                                            ></ds-icon>
                                            <ds-icon
                                                *ngIf="!blockTimeReportSorting.additionalOrgans"
                                                name="expand_more"
                                                size="inherit"
                                                class="margin-left-7"
                                            ></ds-icon>
                                        </div>
                                        <div
                                            class="header-color cursorPointer reportfield-width reportfield-width-14"
                                            (click)="
                                                sortBy = 'groundVendor';
                                                sortOrder = !sortOrder;
                                                blockTimeReportSorting.groundVendor = !blockTimeReportSorting.groundVendor
                                            "
                                        >
                                            Ground Vendor
                                            <ds-icon
                                                *ngIf="blockTimeReportSorting.groundVendor"
                                                name="expand_less"
                                                size="inherit"
                                                class="margin-left-7"
                                            ></ds-icon>
                                            <ds-icon
                                                *ngIf="!blockTimeReportSorting.groundVendor"
                                                name="expand_more"
                                                size="inherit"
                                                class="margin-left-7"
                                            ></ds-icon>
                                        </div>
                                        <div
                                            class="header-color cursorPointer reportfield-width"
                                            (click)="
                                                sortBy = 'unosid';
                                                sortOrder = !sortOrder;
                                                blockTimeReportSorting.unosid = !blockTimeReportSorting.unosid
                                            "
                                        >
                                            Unos ID
                                            <ds-icon
                                                *ngIf="blockTimeReportSorting.unosid"
                                                name="expand_less"
                                                size="inherit"
                                                class="margin-left-7"
                                            ></ds-icon>
                                            <ds-icon
                                                *ngIf="!blockTimeReportSorting.unosid"
                                                name="expand_more"
                                                size="inherit"
                                                class="margin-left-7"
                                            ></ds-icon>
                                        </div>
                                        <div
                                            class="header-color cursorPointer reportfield-width reportfield-width-14"
                                            (click)="
                                                sortBy = 'blockTimeRecordStatus';
                                                sortOrder = !sortOrder;
                                                blockTimeReportSorting.blockTimeRecordStatus = !blockTimeReportSorting.blockTimeRecordStatus
                                            "
                                        >
                                            Block Time Status
                                            <ds-icon
                                                *ngIf="blockTimeReportSorting.blockTimeRecordStatus"
                                                name="expand_less"
                                                size="inherit"
                                                class="margin-left-7"
                                            ></ds-icon>
                                            <ds-icon
                                                *ngIf="!blockTimeReportSorting.blockTimeRecordStatus"
                                                name="expand_more"
                                                size="inherit"
                                                class="margin-left-7"
                                            ></ds-icon>
                                        </div>
                                        <div
                                            class="header-color cursorPointer reportfield-width"
                                            (click)="
                                                sortBy = 'airVendor';
                                                sortOrder = !sortOrder;
                                                blockTimeReportSorting.airVendor = !blockTimeReportSorting.airVendor
                                            "
                                        >
                                            Air Vendor
                                            <ds-icon
                                                *ngIf="blockTimeReportSorting.airVendor"
                                                name="expand_less"
                                                size="inherit"
                                                class="margin-left-7"
                                            ></ds-icon>
                                            <ds-icon
                                                *ngIf="!blockTimeReportSorting.airVendor"
                                                name="expand_more"
                                                size="inherit"
                                                class="margin-left-7"
                                            ></ds-icon>
                                        </div>
                                        <div
                                            class="header-color cursorPointer reportfield-width"
                                            (click)="
                                                sortBy = 'outboundReposition';
                                                sortOrder = !sortOrder;
                                                blockTimeReportSorting.outboundReposition = !blockTimeReportSorting.outboundReposition
                                            "
                                        >
                                            OB Repo
                                            <ds-icon
                                                *ngIf="blockTimeReportSorting.outboundReposition"
                                                name="expand_less"
                                                size="inherit"
                                                class="margin-left-7"
                                            ></ds-icon>
                                            <ds-icon
                                                *ngIf="!blockTimeReportSorting.outboundReposition"
                                                name="expand_more"
                                                size="inherit"
                                                class="margin-left-7"
                                            ></ds-icon>
                                        </div>
                                        <div
                                            class="header-color cursorPointer reportfield-width"
                                            (click)="
                                                sortBy = 'obEstimatedBlockHours';
                                                sortOrder = !sortOrder;
                                                blockTimeReportSorting.obEstimatedBlockHours = !blockTimeReportSorting.obEstimatedBlockHours
                                            "
                                        >
                                            OB Repo Hours
                                            <ds-icon
                                                *ngIf="blockTimeReportSorting.obEstimatedBlockHours"
                                                name="expand_less"
                                                size="inherit"
                                                class="margin-left-7"
                                            ></ds-icon>
                                            <ds-icon
                                                *ngIf="!blockTimeReportSorting.obEstimatedBlockHours"
                                                name="expand_more"
                                                size="inherit"
                                                class="margin-left-7"
                                            ></ds-icon>
                                        </div>
                                        <div
                                            class="header-color cursorPointer reportfield-width"
                                            (click)="
                                                sortBy = 'routing';
                                                sortOrder = !sortOrder;
                                                blockTimeReportSorting.routing = !blockTimeReportSorting.routing
                                            "
                                        >
                                            Routing
                                            <ds-icon
                                                *ngIf="blockTimeReportSorting.routing"
                                                name="expand_less"
                                                size="inherit"
                                                class="margin-left-7"
                                            ></ds-icon>
                                            <ds-icon
                                                *ngIf="!blockTimeReportSorting.routing"
                                                name="expand_more"
                                                size="inherit"
                                                class="margin-left-7"
                                            ></ds-icon>
                                        </div>
                                        <div
                                            class="header-color cursorPointer reportfield-width"
                                            (click)="
                                                sortBy = 'liveFlightHours';
                                                sortOrder = !sortOrder;
                                                blockTimeReportSorting.routing = !blockTimeReportSorting.liveFlightHours
                                            "
                                        >
                                            Live Flight Hours
                                            <ds-icon
                                                *ngIf="blockTimeReportSorting.liveFlightHours"
                                                name="expand_less"
                                                size="inherit"
                                                class="margin-left-7"
                                            ></ds-icon>
                                            <ds-icon
                                                *ngIf="!blockTimeReportSorting.liveFlightHours"
                                                name="expand_more"
                                                size="inherit"
                                                class="margin-left-7"
                                            ></ds-icon>
                                        </div>
                                        <div
                                            class="header-color cursorPointer reportfield-width"
                                            (click)="
                                                sortBy = 'inboundReposition';
                                                sortOrder = !sortOrder;
                                                blockTimeReportSorting.inboundReposition = !blockTimeReportSorting.inboundReposition
                                            "
                                        >
                                            IB Repo
                                            <ds-icon
                                                *ngIf="blockTimeReportSorting.inboundReposition"
                                                name="expand_less"
                                                size="inherit"
                                                class="margin-left-7"
                                            ></ds-icon>
                                            <ds-icon
                                                *ngIf="!blockTimeReportSorting.inboundReposition"
                                                name="expand_more"
                                                size="inherit"
                                                class="margin-left-7"
                                            ></ds-icon>
                                        </div>
                                        <div
                                            class="header-color cursorPointer reportfield-width"
                                            (click)="
                                                sortBy = 'ibEstimatedBlockHours';
                                                sortOrder = !sortOrder;
                                                blockTimeReportSorting.ibEstimatedBlockHours = !blockTimeReportSorting.ibEstimatedBlockHours
                                            "
                                        >
                                            IB Repo Hours
                                            <ds-icon
                                                *ngIf="blockTimeReportSorting.ibEstimatedBlockHours"
                                                name="expand_less"
                                                size="inherit"
                                                class="margin-left-7"
                                            ></ds-icon>
                                            <ds-icon
                                                *ngIf="!blockTimeReportSorting.ibEstimatedBlockHours"
                                                name="expand_more"
                                                size="inherit"
                                                class="margin-left-7"
                                            ></ds-icon>
                                        </div>
                                        <div
                                            class="header-color cursorPointer reportfield-width reportfield-width-14"
                                            (click)="
                                                sortBy = 'tailNumber';
                                                sortOrder = !sortOrder;
                                                blockTimeReportSorting.tailNumber = !blockTimeReportSorting.tailNumber
                                            "
                                        >
                                            Tail Number
                                            <ds-icon
                                                *ngIf="blockTimeReportSorting.tailNumber"
                                                name="expand_less"
                                                size="inherit"
                                                class="margin-left-7"
                                            ></ds-icon>
                                            <ds-icon
                                                *ngIf="!blockTimeReportSorting.tailNumber"
                                                name="expand_more"
                                                size="inherit"
                                                class="margin-left-7"
                                            ></ds-icon>
                                        </div>
                                        <div
                                            class="header-color cursorPointer reportfield-width reportfield-width-14"
                                            (click)="
                                                sortBy = 'aircraftType';
                                                sortOrder = !sortOrder;
                                                blockTimeReportSorting.aircraftType = !blockTimeReportSorting.aircraftType
                                            "
                                        >
                                            Aircraft Types
                                            <ds-icon
                                                *ngIf="blockTimeReportSorting.aircraftType"
                                                name="expand_less"
                                                size="inherit"
                                                class="margin-left-7"
                                            ></ds-icon>
                                            <ds-icon
                                                *ngIf="!blockTimeReportSorting.aircraftType"
                                                name="expand_more"
                                                size="inherit"
                                                class="margin-left-7"
                                            ></ds-icon>
                                        </div>
                                        <div
                                            class="header-color cursorPointer reportfield-width reportfield-width-14"
                                            (click)="
                                                sortBy = 'estimatedBlockHours';
                                                sortOrder = !sortOrder;
                                                blockTimeReportSorting.estimatedBlockHours = !blockTimeReportSorting.estimatedBlockHours
                                            "
                                        >
                                            Est. Block Hours
                                            <ds-icon
                                                *ngIf="blockTimeReportSorting.estimatedBlockHours"
                                                name="expand_less"
                                                size="inherit"
                                                class="margin-left-7"
                                            ></ds-icon>
                                            <ds-icon
                                                *ngIf="!blockTimeReportSorting.estimatedBlockHours"
                                                name="expand_more"
                                                size="inherit"
                                                class="margin-left-7"
                                            ></ds-icon>
                                        </div>
                                        <div
                                            class="header-color cursorPointer reportfield-width reportfield-width-17"
                                            (click)="
                                                sortBy = 'blockHours';
                                                sortOrder = !sortOrder;
                                                blockTimeReportSorting.actualBlockTime = !blockTimeReportSorting.actualBlockTime
                                            "
                                        >
                                            Actual Block Time
                                            <ds-icon
                                                *ngIf="blockTimeReportSorting.actualBlockTime"
                                                name="expand_less"
                                                size="inherit"
                                                class="margin-left-7"
                                            ></ds-icon>
                                            <ds-icon
                                                *ngIf="!blockTimeReportSorting.actualBlockTime"
                                                name="expand_more"
                                                size="inherit"
                                                class="margin-left-7"
                                            ></ds-icon>
                                        </div>
                                        <div
                                            class="header-color cursorPointer reportfield-width reportfield-width-17"
                                            (click)="
                                                sortBy = 'cancellationHours';
                                                sortOrder = !sortOrder;
                                                blockTimeReportSorting.cancellationHours = !blockTimeReportSorting.cancellationHours
                                            "
                                        >
                                            Cancellation Hours
                                            <ds-icon
                                                *ngIf="blockTimeReportSorting.cancellationHours"
                                                name="expand_less"
                                                size="inherit"
                                                class="margin-left-7"
                                            ></ds-icon>
                                            <ds-icon
                                                *ngIf="!blockTimeReportSorting.cancellationHours"
                                                name="expand_more"
                                                size="inherit"
                                                class="margin-left-7"
                                            ></ds-icon>
                                        </div>
                                        <div
                                            class="header-color cursorPointer reportfield-width reportfield-width-14"
                                            (click)="
                                                sortBy = 'aircraftSize';
                                                sortOrder = !sortOrder;
                                                blockTimeReportSorting.aircraftSize = !blockTimeReportSorting.aircraftSize
                                            "
                                        >
                                            Aircraft Size
                                            <ds-icon
                                                *ngIf="blockTimeReportSorting.aircraftSize"
                                                name="expand_less"
                                                size="inherit"
                                                class="margin-left-7"
                                            ></ds-icon>
                                            <ds-icon
                                                *ngIf="!blockTimeReportSorting.aircraftSize"
                                                name="expand_more"
                                                size="inherit"
                                                class="margin-left-7"
                                            ></ds-icon>
                                        </div>
                                        <div
                                            class="header-color cursorPointer reportfield-width"
                                            (click)="
                                                sortBy = 'cost';
                                                sortOrder = !sortOrder;
                                                blockTimeReportSorting.cost = !blockTimeReportSorting.cost
                                            "
                                        >
                                            Cost
                                            <ds-icon
                                                *ngIf="blockTimeReportSorting.cost"
                                                name="expand_less"
                                                size="inherit"
                                                class="margin-left-7"
                                            ></ds-icon>
                                            <ds-icon
                                                *ngIf="!blockTimeReportSorting.cost"
                                                name="expand_more"
                                                size="inherit"
                                                class="margin-left-7"
                                            ></ds-icon>
                                        </div>
                                        <div
                                            class="header-color cursorPointer reportfield-width"
                                            (click)="
                                                sortBy = 'profit';
                                                sortOrder = !sortOrder;
                                                blockTimeReportSorting.profit = !blockTimeReportSorting.profit
                                            "
                                        >
                                            Profit
                                            <ds-icon
                                                *ngIf="blockTimeReportSorting.profit"
                                                name="expand_less"
                                                size="inherit"
                                                class="margin-left-7"
                                            ></ds-icon>
                                            <ds-icon
                                                *ngIf="!blockTimeReportSorting.profit"
                                                name="expand_more"
                                                size="inherit"
                                                class="margin-left-7"
                                            ></ds-icon>
                                        </div>
                                        <div
                                            class="header-color cursorPointer reportfield-width"
                                            (click)="
                                                sortBy = 'rate';
                                                sortOrder = !sortOrder;
                                                blockTimeReportSorting.rate = !blockTimeReportSorting.rate
                                            "
                                        >
                                            Rate
                                            <ds-icon
                                                *ngIf="blockTimeReportSorting.rate"
                                                name="expand_less"
                                                size="inherit"
                                                class="margin-left-7"
                                            ></ds-icon>
                                            <ds-icon
                                                *ngIf="!blockTimeReportSorting.rate"
                                                name="expand_more"
                                                size="inherit"
                                                class="margin-left-7"
                                            ></ds-icon>
                                        </div>
                                        <div
                                            class="header-color cursorPointer reportfield-width reportfield-width-14"
                                            (click)="
                                                sortBy = 'flightMargin';
                                                sortOrder = !sortOrder;
                                                blockTimeReportSorting.flightMargin = !blockTimeReportSorting.flightMargin
                                            "
                                        >
                                            Flight Margin
                                            <ds-icon
                                                *ngIf="blockTimeReportSorting.flightMargin"
                                                name="expand_less"
                                                size="inherit"
                                                class="margin-left-7"
                                            ></ds-icon>
                                            <ds-icon
                                                *ngIf="!blockTimeReportSorting.flightMargin"
                                                name="expand_more"
                                                size="inherit"
                                                class="margin-left-7"
                                            ></ds-icon>
                                        </div>
                                        <div
                                            class="header-color cursorPointer reportfield-width"
                                            (click)="
                                                sortBy = 'invoiceID';
                                                sortOrder = !sortOrder;
                                                blockTimeReportSorting.invoiceID = !blockTimeReportSorting.invoiceID
                                            "
                                        >
                                            Invoice #
                                            <ds-icon
                                                *ngIf="blockTimeReportSorting.invoiceID"
                                                name="expand_less"
                                                size="inherit"
                                                class="margin-left-7"
                                            ></ds-icon>
                                            <ds-icon
                                                *ngIf="!blockTimeReportSorting.invoiceID"
                                                name="expand_more"
                                                size="inherit"
                                                class="margin-left-7"
                                            ></ds-icon>
                                        </div>
                                        <div
                                            class="header-color cursorPointer reportfield-width d-flex justify-content-center"
                                            (click)="
                                                sortBy = 'ar';
                                                sortOrder = !sortOrder;
                                                blockTimeReportSorting.ar = !blockTimeReportSorting.ar
                                            "
                                        >
                                            <span>A/R</span>
                                            <ds-icon
                                                *ngIf="blockTimeReportSorting.ar"
                                                name="expand_less"
                                                size="inherit"
                                                class="margin-left-7"
                                            ></ds-icon>
                                            <ds-icon
                                                *ngIf="!blockTimeReportSorting.ar"
                                                name="expand_more"
                                                size="inherit"
                                                class="margin-left-7"
                                            ></ds-icon>
                                        </div>
                                        <div
                                            class="header-color cursorPointer reportfield-width d-flex justify-content-center"
                                            (click)="
                                                sortBy = 'ap';
                                                sortOrder = !sortOrder;
                                                blockTimeReportSorting.ap = !blockTimeReportSorting.ap
                                            "
                                        >
                                            <span>A/P</span>
                                            <ds-icon
                                                *ngIf="blockTimeReportSorting.ap"
                                                name="expand_less"
                                                size="inherit"
                                                class="margin-left-7"
                                            ></ds-icon>
                                            <ds-icon
                                                *ngIf="!blockTimeReportSorting.ap"
                                                name="expand_more"
                                                size="inherit"
                                                class="margin-left-7"
                                            ></ds-icon>
                                        </div>
                                        <div class="header-color cursorPointer reportfield-width">
                                            <span>Note</span>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                *ngFor="
                                    let record of blockTimeReportData
                                        | filterIbRepoAwaitingVerification: showAwaitingVerificationOnly
                                        | orderBy: sortBy : sortOrder
                                        | filter: searchText
                                        | paginate: { itemsPerPage: selectedPage, currentPage: currentPageNumber };
                                    let record_index = index
                                "
                            >
                                <td>
                                    <div id="blocktimeRecord_main_row_id" class="row_container">
                                        <div
                                            class="title_container reportfield-width position-sticky left-minus_0_5"
                                            [ngClass]="
                                                record_index % 2 == 0
                                                    ? 'background-color-white box-shadow-white'
                                                    : 'background-color-whiteSmoke box-shadow-whiteSmoke'
                                            "
                                        >
                                            <div class="row_title">Action</div>
                                            <div class="row_detail">
                                                <button
                                                    id="editBlockTimeReportButton"
                                                    class="mr-2 flat-butt flat-info-butt flat-info-grad-butt add-note-button"
                                                    title="Edit blocktime record"
                                                    [disabled]="isInternalReadOnly"
                                                    [ngClass]="isInternalReadOnly ? 'notAllowedPointer' : ''"
                                                    (click)="openEditBlockTimeReport(record)"
                                                >
                                                    <ds-icon name="edit" size="inherit"></ds-icon>
                                                </button>
                                                <button
                                                    id="deleteBlockTimeReportButton"
                                                    class="flat-butt flat-info-butt flat-info-grad-butt add-note-button"
                                                    title="Delete blocktime record"
                                                    [disabled]="!record.blockTimeReportID || isInternalReadOnly"
                                                    [ngClass]="isInternalReadOnly || !record.blockTimeReportID ? 'notAllowedPointer' : ''"
                                                    (click)="deleteBlockTimeRecord(record.blockTimeReportID)"
                                                >
                                                    <ds-icon name="remove_circle" size="inherit"></ds-icon>
                                                </button>
                                                <button
                                                    *ngIf="!record.isRecordSplitted && record.parentBlockTimeReportID == null"
                                                    id="splitBlockTimeReportButton"
                                                    class="flat-butt flat-info-butt flat-info-grad-butt add-note-button"
                                                    title="Split the record"
                                                    [disabled]="isInternalReadOnly"
                                                    [ngClass]="isInternalReadOnly ? 'notAllowedPointer' : ''"
                                                    (click)="openSplitBlockTimeRecordPopup(record)"
                                                >
                                                    <ds-icon name="content_cut" size="inherit"></ds-icon>
                                                </button>
                                            </div>
                                        </div>
                                        <div
                                            class="title_container reportfield-width position-sticky left-9_5"
                                            [ngClass]="record_index % 2 == 0 ? 'background-color-white' : 'background-color-whiteSmoke'"
                                        >
                                            <div class="row_title">Date</div>
                                            <div class="row_detail">
                                                {{ record?.srCreatedOnDate | date: timeZone }}
                                            </div>
                                        </div>
                                        <div
                                            class="title_container reportfield-width position-sticky left-19_5"
                                            [ngClass]="record_index % 2 == 0 ? 'background-color-white' : 'background-color-whiteSmoke'"
                                        >
                                            <div class="row_title">Trip #</div>
                                            <div class="row_detail cursorPointer">
                                                <a href="{{ itineraryPageRedirectUrl }}/{{ record.serviceRequestID }}/Report">
                                                    {{ record.tripID }}
                                                </a>
                                            </div>
                                        </div>
                                        <div
                                            class="title_container reportfield-width position-sticky left-29_5"
                                            [ngClass]="record_index % 2 == 0 ? 'background-color-white' : 'background-color-whiteSmoke'"
                                        >
                                            <div class="row_title">Customer</div>
                                            <div class="row_detail">
                                                {{ record?.customer?.customerName }}
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width">
                                            <div class="row_title">SR Type</div>
                                            <div class="row_detail">
                                                {{ record.serviceType }}
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width reportfield-width-14">
                                            <div class="row_title">Organ Type</div>
                                            <div class="row_detail" style="max-height: 5rem; overflow-y: auto">
                                                {{ record.additionalOrgans }}
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width reportfield-width-14">
                                            <div class="row_title">Ground Vendor</div>
                                            <div class="row_detail">
                                                {{ record.groundVendor }}
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width">
                                            <div class="row_title">Unos ID</div>
                                            <div class="row_detail">
                                                {{ record.unosid }}
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width reportfield-width-14">
                                            <div class="row_title">Block Time Status</div>
                                            <div class="row_detail">
                                                {{ record.blockTimeRecordStatus | blockTimeRecordStatusLabel }}
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width">
                                            <div class="row_title">Air Vendor</div>
                                            <div class="row_detail">
                                                {{ record.airVendor }}
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width">
                                            <div class="row_title">OB Repo</div>
                                            <div class="row_detail">
                                                {{ record.outboundReposition }}
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width">
                                            <div class="row_title">OB Repo Hours</div>
                                            <div class="row_detail">
                                                {{ record.obEstimatedBlockHours | number: '1.2-2' }}
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width">
                                            <div class="row_title">Routing</div>
                                            <div class="row_detail">
                                                {{ record.routing }}
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width">
                                            <div class="row_title">Live Flight Hours</div>
                                            <div class="row_detail">
                                                {{ record.liveFlightHours }}
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width">
                                            <div class="row_title">IB Repo</div>
                                            <div class="row_detail">
                                                <ng-container *ngIf="record.actualInBoundReposition">
                                                    <span class="ib-repo-planned">{{ record.inboundReposition }}</span>
                                                    → {{ record.actualInBoundReposition }}
                                                </ng-container>
                                                <ng-container *ngIf="!record.actualInBoundReposition">
                                                    {{ record.inboundReposition }}
                                                </ng-container>
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width">
                                            <div class="row_title">IB Repo Hours</div>
                                            <div class="row_detail">
                                                {{ record.ibEstimatedBlockHours | number: '1.2-2' }}
                                                <app-ds-badge
                                                    *ngIf="record.ibRepoAwaitingVerification"
                                                    class="needs-review-badge"
                                                    label="Needs verification"
                                                    size="sm"
                                                    theme="warning"
                                                    [matTooltip]="record | ibRepoVerificationTooltip"
                                                ></app-ds-badge>
                                                <app-ds-badge
                                                    *ngIf="record.ibRepoVerified"
                                                    class="needs-review-badge"
                                                    label="Verified"
                                                    size="sm"
                                                    theme="success"
                                                    [matTooltip]="
                                                        getIbRepoVerifiedTooltip(
                                                            record.ibRepoVerifiedByName,
                                                            record.ibRepoVerifiedOn | srTimezoneDate
                                                        )
                                                    "
                                                ></app-ds-badge>
                                                <button
                                                    *ngIf="record.ibRepoNeedsVerification && canVerifyIbRepo"
                                                    type="button"
                                                    class="ib-repo-verify-btn"
                                                    (click)="openIbRepoVerification(record)"
                                                >
                                                    {{ record.ibRepoVerified ? 'Edit verification' : 'Verify' }}
                                                </button>
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width reportfield-width-14">
                                            <div class="row_title">Tail Number</div>
                                            <div class="row_detail">
                                                <a href="https://flightaware.com/live/flight/{{ record.tailNumber }}" target="blank">
                                                    {{ record.tailNumber }}
                                                </a>
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width reportfield-width-14">
                                            <div class="row_title">Aircraft Types</div>
                                            <div class="row_detail">
                                                {{ record.aircraftType }}
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width reportfield-width-14">
                                            <div class="row_title">Est. Block Hours</div>
                                            <div class="row_detail">
                                                {{ record.estimatedBlockHours }}
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width reportfield-width-17">
                                            <div class="row_title">Actual Block Time</div>
                                            <div class="row_detail">
                                                {{ record.actualBlockTime }}
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width reportfield-width-17">
                                            <div class="row_title">Cancellation Hours</div>
                                            <div class="row_detail">
                                                {{ record.cancellationHours | number: '1.2-2' }}
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width reportfield-width-14">
                                            <div class="row_title">Aircraft Size</div>
                                            <div class="row_detail">
                                                {{ record.aircraftSize }}
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width">
                                            <div class="row_title">Cost</div>
                                            <div class="row_detail">
                                                <ng-container *ngIf="record.cost"> {{ record.cost }} $ </ng-container>
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width">
                                            <div class="row_title">Profit</div>
                                            <div class="row_detail">
                                                <ng-container *ngIf="record.profit"> {{ record.profit }} $ </ng-container>
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width">
                                            <div class="row_title">Rate</div>
                                            <div class="row_detail">
                                                <ng-container *ngIf="record.rate"> {{ record.rate }} % </ng-container>
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width reportfield-width-14">
                                            <div class="row_title">Flight Margin</div>
                                            <div class="row_detail">
                                                <ng-container *ngIf="record.flightMargin"> {{ record.flightMargin }} % </ng-container>
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width">
                                            <div class="row_title">Invoice #</div>
                                            <div class="row_detail">
                                                {{ record.invoiceID }}
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width">
                                            <div class="row_title">A/R</div>
                                            <div class="row_detail d-flex justify-content-center">
                                                <input
                                                    class="block_time_report_checkbox"
                                                    type="checkbox"
                                                    [disabled]="isInternalReadOnly"
                                                    [(ngModel)]="record.ar"
                                                    (change)="updateArOrAp(record, 'A/R')"
                                                />
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width">
                                            <div class="row_title">A/P</div>
                                            <div class="row_detail d-flex justify-content-center">
                                                <input
                                                    class="block_time_report_checkbox"
                                                    type="checkbox"
                                                    [disabled]="isInternalReadOnly"
                                                    [(ngModel)]="record.ap"
                                                    (change)="updateArOrAp(record, 'A/P')"
                                                />
                                            </div>
                                        </div>
                                        <div class="title_container reportfield-width">
                                            <div class="row_title">Note</div>
                                            <div class="row_detail">
                                                <input
                                                    id="note-{{ record_index }}"
                                                    class="form-control cursorPointer"
                                                    data-placement="auto left"
                                                    data-toggle="popover"
                                                    readonly
                                                    type="textarea"
                                                    [attr.data-content]="record.note"
                                                    [(ngModel)]="record.note"
                                                    (click)="togglePopOver()"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div *ngIf="blockTimeReportData.length == 0" class="mt-2" style="color: #a82b41">
                    <b>No Records Found</b>
                </div>
                <div *ngIf="blockTimeReportData.length > 0" class="col-md-12 p-3">
                    <div class="col-md-6 p-0">
                        {{ pagination }}
                    </div>
                    <div class="col-md-6 pagination text-end mt-1">
                        <pagination-controls
                            [maxSize]="6"
                            [nextLabel]="''"
                            [previousLabel]="''"
                            [responsive]="responsive"
                            (pageChange)="currentPageNumber = $event; onPageChange()"
                        >
                        </pagination-controls>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<app-block-time-report-grid [data]="totalOfBlockTimeReportValues"></app-block-time-report-grid>
